import { Injectable, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { Talent } from '../models/talent.model';
import { environment } from "../../environments/environment";

@Injectable()
export class TalentService {
  private talents: Talent[];
  selectedClient;
  talentApi = environment.apiUrl + "/talent";
  @Output() getJobTitle: EventEmitter<any> = new EventEmitter();

  constructor(private http: Http) {
    this.selectedClient = localStorage.getItem("selectedClient");
  }

  ngOnInit() {
    this.selectedClient = localStorage.getItem("selectedClient");
  }

  getTalentsByClient(clientId: string,token:string) {     
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  
    return this.http.get(this.talentApi + '?clientId=' + clientId + "&token=" +token,{headers: headers});
  }

  getTalentsByClientJobtitle(clientId: string, jobFamily: string,token:string,sort:string,poolId: string) {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  

    let loggedInClientUser = JSON.parse(localStorage.getItem("loggedInClientUser"));
    let queryParams = 'userParentId='+btoa(clientId);
    if(loggedInClientUser) {
      queryParams += '&userEmail='+btoa(loggedInClientUser.email);
    }
    return this.http.get(this.talentApi + '?usertype=client&clientId=' + clientId + "&"+queryParams+"&talentPool="+encodeURIComponent(poolId) +"&token=" + token +"&sort=" + sort+"&jobFamily=" + encodeURIComponent(jobFamily),{headers: headers});
  }

  getOneTalent(talentId: string) : Promise<any> {     
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  
    return this.http.get(this.talentApi + '/' + talentId, {headers: headers}).map(response => {
      return response;
    }).toPromise();
  }

  addTalent(talentData: Object) {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.post(this.talentApi, talentData,{headers: headers});
  }

  updateTalent(talentId: string, talentData: any) {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.post(this.talentApi + '/' + talentId, talentData ,{headers: headers});
  }

  autoSaveTalent(talentId: string, talentData: Object) {
   // console.log(talentId);
    let apiURL = (talentId) ? this.talentApi + '/' + talentId : this.talentApi;    
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.patch(apiURL, talentData,{headers: headers}).map(response => {
              return response;
            }).toPromise(); 
  }

  deleteTalent(talentId: string){
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    return this.http.delete(this.talentApi + '/' + talentId ,{headers: headers});
  }

  getTalentById(talentId: string,clientid: string,token:string) : Promise<Talent> {
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")} );  
    
    let loggedInClientUser = JSON.parse(localStorage.getItem("loggedInClientUser"));
    let queryParams = 'userParentId='+btoa(clientid);
    if(loggedInClientUser) {
      queryParams += '&userEmail='+btoa(loggedInClientUser.email);
    }  
      return this.http.get(this.talentApi + '/' + talentId + '?'+queryParams, {headers: headers})
        .map(response => {
                return response.json();
            }).toPromise();  
  }

  getFilterResult(talentData: Object,token:string,sort){
   // console.log(talentData);
    const headers = new Headers({ 'Content-Type' : 'application/json' , 'Authorization' : localStorage.getItem("idToken")});
    let loggedInClientUser = JSON.parse(localStorage.getItem("loggedInClientUser"));
    let queryParams = 'userParentId='+btoa(talentData['clientId']);
    if(loggedInClientUser) {
      queryParams += '&userEmail='+btoa(loggedInClientUser.email);
    }

    return this.http.get(this.talentApi + '?clientId='+talentData['clientId']+'&'+queryParams+'&talentPool='+encodeURIComponent(talentData['talentPool'])+'&jobFamily='+encodeURIComponent(talentData['jobFamily'])+'&skill='+talentData['skill']+'&minExp='+talentData['minExp']+'&maxExp='+talentData['maxExp']+'&minSal='+talentData['minSal']+'&maxSal='+talentData['maxSal']+'&education='+talentData['education']+'&eligibility='+talentData['eligibility']+'&noticePeriod='+talentData['noticePeriod']+'&contract='+talentData['contract']+'&matchRating='+talentData['matchRating']+"&token=" + token+"&sort=" + sort, {headers: headers});
  }
  selectedJobTitle(jobtitle){
    this.getJobTitle.emit(jobtitle);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/talent.service.ts